import styled from 'styled-components';

export const ImgPreview = styled.img`
  object-fit: cover;
  object-position: center;
  border-radius: 10px 10px 0 0;
`;
